import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Constants, Environments } from 'src/app/config/app.constants';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private router: Router, private constants: Constants) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let isAllowed = false;
    switch (this.constants.environmentName) {
      case Environments.Development:
        isAllowed = true;
        break;
      case Environments.Stage:
        isAllowed = this.validateToken(state);
        break;
      case Environments.Production:
        if (route.data && !route.data['login']) {
          isAllowed = true;
        } else {
          isAllowed = this.validateToken(state);
        }
        break;
    }
    return isAllowed;

  }

  validateToken(state: RouterStateSnapshot): boolean {
    const url = state.url;
    const isSSR = typeof window === 'undefined';
    if (isSSR)
      return true;
    if (this.hasAuthCookie()) {
      return true;
    }
    this.router.navigate(["login"], { queryParams: { returnUrl: url } });
    return false;
  }

  private hasAuthCookie(): boolean {
    if (typeof document === 'undefined') {
      return false;
    }
    return document.cookie.split(';').some((c) => c.trim().startsWith('authState='));
  }
}
